import Layout from '../views/layout/Layout'

export default {
  path: '/dashboard',
  component: Layout,
  redirect: 'noredirect',
  name: 'dashboard',
  meta: {
    title: 'Dashboard',
    elicon: 'el-icon-fa-bar-chart',
    roles: [],
  },
  children: [
    {
      path: 'overview',
      name: 'dashboard.overview',
      component: () => import('@/views/dashboard/overview'),
      meta: {
        title: '总览',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'material/query',
      name: 'dashboard.material.query',
      component: () => import('@/views/dashboard/material/query'),
      meta: {
        title: '素材信息查询',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'report',
      name: 'dashboard.report',
      component: () => import('@/views/dashboard/report'),
      meta: {
        title: 'Playable投放数据统计',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'material/playsmart',
      name: 'dashboard.playsmart',
      component: () => import('@/views/dashboard/material/playsmart'),
      meta: {
        title: 'PlaySmart投放数据统计',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'playturbo',
      name: 'dashboard.playturbo',
      component: () => import('@/views/dashboard/playturbo'),
      meta: {
        title: 'Playturbo看板',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'template-use',
      name: 'dashboard.template-use',
      component: () => import('@/views/dashboard/template-use'),
      meta: {
        title: '订阅工具使用监控',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'channel-launch',
      name: 'dashboard.channel-launch',
      component: () => import('@/views/dashboard/channel-launch'),
      meta: {
        title: '多渠道投放数据',
        roles: ['dashboard.read'],
      },
    },
    {
      path: 'pt-user-dashboard',
      name: 'dashboard.pt-user-dashboard',
      component: () => import('@/views/dashboard/pt-user-dashboard'),
      redirect: 'pt-user-dashboard/summary',
      meta: {
        title: 'playturbo客户使用监控',
        roles: ['dashboard.read'],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'summary',
          name: 'dashboard.pt-user-dashboard.summary',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/summary'),
          meta: {
            title: '总览',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'template',
          name: 'dashboard.pt-user-dashboard.template',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/template'),
          meta: {
            title: '模板使用情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'version',
          name: 'dashboard.pt-user-dashboard.version',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/version'),
          meta: {
            title: '版本制作情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'ai-usage',
          name: 'dashboard.pt-user-dashboard.ai-usage',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/ai-usage'),
          meta: {
            title: 'AI 服务使用情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'vrecord-usage',
          name: 'dashboard.pt-user-dashboard.vrecord-usage',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/vrecord-usage'),
          meta: {
            title: '录屏工具使用情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'veditor-usage',
          name: 'dashboard.pt-user-dashboard.veditor-usage',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/veditor-usage'),
          meta: {
            title: '录屏工具使用情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'cloud-clip',
          name: 'dashboard.pt-user-dashboard.cloud-clip',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/cloud-clip'),
          meta: {
            title: '云剪辑',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'subscription-material-push',
          name: 'dashboard.pt-user-dashboard.subscription-material-push',
          component: () =>
            import(
              '@/views/dashboard/pt-user-dashboard/subscription-material-push'
            ),
          meta: {
            title: '订阅素材下载推送情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'custom-material-push',
          name: 'dashboard.pt-user-dashboard.custom-material-push',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/custom-material-push'),
          meta: {
            title: '定制素材下载推送情况',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'playable-project',
          name: 'dashboard.pt-user-dashboard.playable-project',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/playable-project'),
          meta: {
            title: '可玩项目监控',
            roles: ['dashboard.read'],
          },
        },
        {
          path: 'video-project',
          name: 'dashboard.pt-user-dashboard.video-project',
          component: () =>
            import('@/views/dashboard/pt-user-dashboard/video-project'),
          meta: {
            title: '视频项目监控',
            roles: ['dashboard.read'],
          },
        },
      ],
    },
  ],
}
